import React from "react";
import FileUpload from "../../../../components/FileUpload/FileUpload";

interface RCAAttachmentsSectionProps {
  files: File[] | null;
  onFilesChange: (files: File[] | null) => void;
  existingAttachments: any[];
  onRemoveExistingAttachment: (index: number) => void;
  onPreviewFile: (attachment: any) => void;
  uploading: boolean;
  uploadProgress: number;
  disabled: boolean;
  getRootProps: any;
  getInputProps: any;
}

const RCAAttachmentsSection: React.FC<RCAAttachmentsSectionProps> = ({
  files,
  onFilesChange,
  existingAttachments,
  onRemoveExistingAttachment,
  onPreviewFile,
  uploading,
  uploadProgress,
  disabled,
  getRootProps,
  getInputProps,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Attachments & Evidence
      </h3>
      <FileUpload
        mode={disabled ? "view" : "update"}
        files={files}
        onFilesChange={onFilesChange}
        existingAttachments={existingAttachments}
        onRemoveExistingAttachment={onRemoveExistingAttachment}
        onPreviewFile={onPreviewFile}
        uploading={uploading}
        uploadProgress={uploadProgress}
        disabled={disabled}
        maxFileSizeMB={25}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
      />
    </div>
  );
};

export default RCAAttachmentsSection;
